import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import type { ReminderEmailState } from "@/context/CampaignBuilderContext";
import ReminderCustomizePanel from "./ReminderCustomizePanel";

interface ReminderDrawerProps {
  open: boolean;
  onClose: () => void;
  state: ReminderEmailState;
  onChange: (v: Partial<ReminderEmailState>) => void;
}

export default function ReminderDrawer({ open, onClose, state, onChange }: ReminderDrawerProps) {
  useEffect(() => {
    if (!open) return;
    function handleKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  return (
    <div
      className="bg-white absolute top-0 right-0 bottom-0 overflow-y-auto"
      style={{
        width: 380,
        transform: open ? "translateX(0)" : "translateX(100%)",
        transition: "transform 0.28s cubic-bezier(0.22, 0.61, 0.36, 1)",
        borderLeft: "1px solid var(--color-card-border)",
        boxShadow: "-12px 0 32px rgba(26, 22, 18, 0.10)",
        pointerEvents: open ? "auto" : "none",
        zIndex: 200,
        willChange: "transform",
      }}
      aria-hidden={!open}
    >
      {/* Header — sticky so it stays visible while body scrolls */}
      <div
        className="sticky top-0 bg-white flex items-center justify-between"
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid var(--color-card-border)",
          zIndex: 1,
        }}
      >
        <div
          className="font-crimson"
          style={{ fontSize: 18, color: "var(--color-rodeo-black)", lineHeight: 1.2 }}
        >
          Customize this reminder
        </div>
        <button
          type="button"
          onClick={onClose}
          className="flex items-center text-graphite hover:text-dark-dust transition-colors"
          style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}
          aria-label="Close customize panel"
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      {/* Body */}
      <div style={{ padding: 20 }}>
        <ReminderCustomizePanel state={state} onChange={onChange} />
      </div>
    </div>
  );
}
